import { defineMessages } from 'react-intl';

export const scope = 'app.component.base.toggle_button';

export default defineMessages({
  toggle_button_checked: {
    id: `${scope}.toggle_button_checked`,
    defaultMessage: 'Toggle button checked',
  },
  toggle_button_unchecked: {
    id: `${scope}.toggle_button_unchecked`,
    defaultMessage: 'Toggle button unchecked',
  },
});
